/** API errors when editing provider profile/media during pending claim review. */

import { apiErrorCodeFromUnknown } from "./apiErrorUtils";

export const CLAIM_PENDING_PROFILE_EDIT_RESTRICTED =
  "CLAIM_PENDING_PROFILE_EDIT_RESTRICTED";

export const CLAIM_PENDING_LOCATION_IMAGE_ACTION = "location_image_mutation";

export const CLAIM_PENDING_EDIT_AWAITING_APPROVAL_MESSAGE =
  "This listing is awaiting ownership verification. Contact and public profile fields cannot be edited until an administrator approves your claim.";

export const CLAIM_PENDING_LOCATION_IMAGE_MESSAGE =
  "Facility photos cannot be added or changed while your claim is awaiting administrator approval.";

type RegistrationErrorBody = {
  code?: string;
  error_code?: string;
  message?: string;
  details?: {
    restricted_action?: string;
    restricted_fields?: string[];
  };
};

type ApiErrorLike = {
  response?: {
    status?: number;
    data?: {
      detail?: string | { error?: RegistrationErrorBody };
      error?: RegistrationErrorBody;
    };
  };
};

function readRegistrationError(
  response: ApiErrorLike["response"]
): RegistrationErrorBody | undefined {
  if (!response || typeof response !== "object") return undefined;
  const payload = response.data;
  if (!payload) return undefined;

  if (payload.error && typeof payload.error === "object") {
    return payload.error;
  }

  const detail = payload.detail;
  if (detail && typeof detail === "object" && detail.error) {
    return detail.error;
  }

  return undefined;
}

export function extractRegistrationErrorCode(error: unknown): string | undefined {
  return apiErrorCodeFromUnknown(error);
}

export function messageForClaimPendingEditRestriction(
  error: unknown,
  fallback: string = CLAIM_PENDING_EDIT_AWAITING_APPROVAL_MESSAGE
): string | null {
  const code = apiErrorCodeFromUnknown(error);
  if (code !== CLAIM_PENDING_PROFILE_EDIT_RESTRICTED) {
    return null;
  }

  const reg = readRegistrationError(
    error && typeof error === "object" && "response" in error
      ? (error as ApiErrorLike).response
      : undefined
  );

  if (reg?.details?.restricted_action === CLAIM_PENDING_LOCATION_IMAGE_ACTION) {
    return reg.message || CLAIM_PENDING_LOCATION_IMAGE_MESSAGE;
  }

  return reg?.message || fallback;
}
